// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3zJQu","rootSuccess":"CompleteLink_rootSuccess__3D9N-","rootFailure":"CompleteLink_rootFailure__3ODaq","isDisabled":"CompleteLink_isDisabled__myzLv"};